import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

export function useScrollToAnchor(...deps: any[]) {
  const LESSON_HEADER_ID = 'lesson-header'
  const location = useLocation()
  const lastHash = useRef('')

  useEffect(() => {
    if (location.hash) {
      lastHash.current = decodeURIComponent(location.hash.slice(1))
    }
    if (lastHash.current && document.getElementById(lastHash.current)) {
      document
        .getElementById(lastHash.current)
        ?.scrollIntoView({ behavior: 'smooth', block: 'start' })
      lastHash.current = ''
    } else if (document.getElementById(LESSON_HEADER_ID)) {
      document
        .getElementById(LESSON_HEADER_ID)
        ?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }, [location, ...deps])

  return null
}
